import { useQueryClient } from "@tanstack/react-query";

export const invalidateShopQueryKey = (shopId: string) => ["get", "/shops/{shopId}", { params: { path: { shopId } } }];

export default function useInvalidateShop(shopId: string) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: invalidateShopQueryKey(shopId) });
  };
}
